<template>
  <div id="monthRangePicker">
    <span class="queryLabel">{{$t(title)}}</span>
    <a-month-picker v-model="planTimeStart" @change="planTimeChange(1)" :placeholder="$t('monthRangePicker.tip.startTime')" :allowClear="false">
      <span slot="suffixIcon">-</span>
    </a-month-picker>
    <a-month-picker
      :open="endOpen"
      @openChange="openChange"
      v-model="planTimeEnd" @change="planTimeChange(2)" :placeholder="$t('monthRangePicker.tip.endTime')">
    </a-month-picker>
  </div>
</template>

<script>
  export default {
    name: 'ptMonthRangePicker',
    props: {
      title:{
        type:String,
        default:''
      },
      value:{
        type: Array ,
      },
    },
    data() {
      return {
        planTimeStart:null,
        planTimeEnd:null,
        endOpen: false,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init(){
        if(this.value != null && this.value.length == 2){
          this.planTimeStart = this.value[0]
          this.planTimeEnd = this.value[1]
        }else{
          this.planTimeStart = null
          this.planTimeEnd = null
        }
      },
      openChange(open){
        this.endOpen = open
      },
      planTimeChange(value){
        console.log("value",value)
        console.log("planTimeEnd",this.planTimeEnd)
        if(value == 1){
          this.endOpen = true
        }
        if(value == 2){
          this.endOpen = false
        }
        if(value == 2 && this.planTimeEnd == null){
          this.planTimeStart = null
          this.$emit('input',[])
          this.$emit('change',[])
        }
        if(this.planTimeStart && this.planTimeEnd){
          this.planTimeStart.startOf('month')
          this.planTimeEnd.endOf('month')
          if(this.planTimeStart.diff(this.planTimeEnd) > 0){
            this.$message.warning(this.$t('monthRangePicker.errorInfo.endTimeBeforeStartTime'))
          }else{
            this.$emit('input',[this.planTimeStart, this.planTimeEnd])
            this.$emit('change',[this.planTimeStart, this.planTimeEnd])
          }
        console.log("planTimeStart",this.planTimeStart)
        console.log("planTimeStart",this.planTimeEnd)
        }
      },
    },
    watch:{
      value(){
        this.init()
      }
    }
  }
</script>

<style scoped lang="less">
  #monthRangePicker{
    display:flex;
    .queryLabel{
      font-size: 14px;
      color: #999999;
    }
  }
</style>